import { createFileRoute } from '@tanstack/react-router';
import { CollaborationQueuePage } from '../../features/shipments';

export const Route = createFileRoute('/portal/shipments/collaboration')({ component: CollaborationQueuePage });
